export const sxDrawer = theme => ({
  drawerPaper: {
    backgroundColor: '#F3F3F3',
    width: '100%', // default (xs)

    // ≥ 1400px → 60%
    [theme.breakpoints.up('xl')]: {
      width: '60%',
    },

    // 1200px–1399px → 70%
    [theme.breakpoints.between('lg', 'xl')]: {
      width: '70%',
    },

    // 900px–1199px → 80%
    [theme.breakpoints.between('md', 'lg')]: {
      width: '80%',
    },

    // 600px–899px → 70%
    [theme.breakpoints.between('sm', 'md')]: {
      width: '70%',
    },

    // ≤ 599px → 100%
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  drawerBox: {
    width: '100%',
    paddingTop: theme.spacing(6),

    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(7),
    },
  },

  closeButton: {
    position: 'fixed',
    top: theme.spacing(1.5),
    right: theme.spacing(1.5),
    zIndex: 1300,
    backgroundColor: theme.primary,
    color: theme.text1,
    padding: theme.spacing(1),

    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
});
